import React, { useState } from "react";
import {
  GraduationCap,
  User,
  Phone,
  Mail,
  MessageCircle,
  Send,
  CheckCircle2,
} from "lucide-react";
import Reveal from "../Reveal";

const experienceOptions = [
  "Nunca trabalhei com banho e tosa",
  "Já tenho alguma experiência",
  "Já trabalho na área",
  "Quero me aperfeiçoar",
];

export default function CoursePreRegistration() {
  const [success, setSuccess] = useState(false);

  const handleSubmit = () => {
    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
    }, 7000);
  };

  return (
    <section
      id="pre-inscricao"
      data-testid="course-pre-registration-section"
      className="relative overflow-hidden py-24 sm:py-32 text-white bg-transparent"
    >
      <div className="container-pad relative z-10">
        <Reveal
          as="div"
          className="relative overflow-hidden rounded-[36px] border border-white/15 bg-white/10 p-7 shadow-[0_35px_100px_rgba(0,0,0,0.28)] sm:p-10 lg:p-12"
        >
          <div className="absolute -left-32 -top-32 h-80 w-80 rounded-full bg-gold/15 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-36 -right-28 h-96 w-96 rounded-full bg-white/10 blur-3xl pointer-events-none" />

          <div className="relative grid gap-12 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-5">
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em]">
                <GraduationCap className="h-4 w-4 text-gold" />
                Curso presencial
              </div>

              <h2 className="font-heading text-3xl leading-[1.1] text-white sm:text-4xl lg:text-5xl">
                Faça sua{" "}
                <span className="italic text-gold">pré-inscrição</span>.
              </h2>

              <p className="mt-5 text-base leading-relaxed text-white/75 sm:text-lg">
                Cadastre seus dados para receber todas as informações sobre o
                curso presencial de banho e tosa, datas, valores e abertura das
                vagas.
              </p>

              <div className="mt-8 space-y-4">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                  <p className="text-sm text-white/75">
                    Do zero ao mercado de trabalho.
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                  <p className="text-sm text-white/75">
                    Conteúdo prático e acompanhamento presencial.
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                  <p className="text-sm text-white/75">
                    A pré-inscrição não garante a vaga e não possui cobrança.
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7">
              <form
                name="pre-inscricao-curso"
                method="POST"
                data-netlify="true"
                netlify-honeypot="bot-field"
                onSubmit={handleSubmit}
                className="rounded-[30px] border border-white/15 bg-[#061738]/45 p-6 shadow-[0_25px_80px_rgba(0,0,0,0.22)] sm:p-8"
              >
                <input
                  type="hidden"
                  name="form-name"
                  value="pre-inscricao-curso"
                />

                <p className="hidden">
                  <label>
                    Não preencha:
                    <input name="bot-field" />
                  </label>
                </p>

                {success && (
                  <div className="mb-6 flex items-start gap-3 rounded-2xl border border-emerald-300/25 bg-emerald-400/15 p-4 text-emerald-100">
                    <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0" />

                    <p className="text-sm font-medium">
                      Pré-inscrição enviada! Entraremos em contato quando as
                      vagas forem abertas.
                    </p>
                  </div>
                )}

                <div className="grid gap-5 sm:grid-cols-2">
                  <label className="block">
                    <span className="mb-2 flex items-center gap-2 text-sm font-semibold text-white">
                      <User className="h-4 w-4 text-gold" />
                      Nome completo *
                    </span>

                    <input
                      type="text"
                      name="nome"
                      required
                      placeholder="Digite seu nome"
                      className="h-12 w-full rounded-xl border border-white/15 bg-white/90 px-4 text-royal outline-none placeholder:text-slate-400 focus:border-gold"
                    />
                  </label>

                  <label className="block">
                    <span className="mb-2 flex items-center gap-2 text-sm font-semibold text-white">
                      <Phone className="h-4 w-4 text-gold" />
                      WhatsApp *
                    </span>

                    <input
                      type="tel"
                      name="whatsapp"
                      required
                      placeholder="(47) 99999-9999"
                      className="h-12 w-full rounded-xl border border-white/15 bg-white/90 px-4 text-royal outline-none placeholder:text-slate-400 focus:border-gold"
                    />
                  </label>

                  <label className="block sm:col-span-2">
                    <span className="mb-2 flex items-center gap-2 text-sm font-semibold text-white">
                      <Mail className="h-4 w-4 text-gold" />
                      E-mail *
                    </span>

                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="seuemail@exemplo.com"
                      className="h-12 w-full rounded-xl border border-white/15 bg-white/90 px-4 text-royal outline-none placeholder:text-slate-400 focus:border-gold"
                    />
                  </label>

                  <label className="block sm:col-span-2">
                    <span className="mb-2 text-sm font-semibold text-white">
                      Qual é a sua experiência?
                    </span>

                    <select
                      name="experiencia"
                      defaultValue=""
                      className="h-12 w-full rounded-xl border border-white/15 bg-white/90 px-4 text-royal outline-none focus:border-gold"
                    >
                      <option value="" disabled>
                        Selecione uma opção
                      </option>

                      {experienceOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label className="block sm:col-span-2">
                    <span className="mb-2 flex items-center gap-2 text-sm font-semibold text-white">
                      <MessageCircle className="h-4 w-4 text-gold" />
                      O que você espera aprender?
                    </span>

                    <textarea
                      name="objetivo"
                      rows={4}
                      placeholder="Conte um pouco sobre o seu interesse no curso..."
                      className="w-full resize-none rounded-xl border border-white/15 bg-white/90 p-4 text-royal outline-none placeholder:text-slate-400 focus:border-gold"
                    />
                  </label>
                </div>

                <div className="mt-6">
                  <button
                    type="submit"
                    className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-gold px-7 py-4 font-bold text-royal shadow-[0_15px_40px_rgba(242,169,0,0.34)] transition-all hover:-translate-y-1 hover:bg-gold-hover sm:w-auto"
                  >
                    <Send className="h-5 w-5" />
                    Fazer pré-inscrição
                  </button>

                  <p className="mt-4 text-xs leading-relaxed text-white/50">
                    Ao enviar, você autoriza o contato da Tia Sandra Pet Care
                    sobre o curso presencial.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
